"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Created on Fri Jun 08 2018
 */

var immutable_1 = require("immutable");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var BigNumberRangeValidator_1 = require("../../core/model/data-dictionary/validators/BigNumberRangeValidator");

var DomainObject_1 = require("../../core/model/DomainObject");

var utils_1 = require("../../core/utils");
/**
 * Family groups related internal products, typically of same brand with different flavors.
 * Each product is mapped with family through so called binding, that preserves information
 * about size ratio and quality charge relative to item leader. Besides mentioned, family is
 * also related to tier and all items in a Family must belong to the same Tier.
 *
 * @author JMe
 */


var Family =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(Family, _DomainObject_1$Domai);

  /**
   * Creates new object of family.
   *
   * @param id the id of family
   * @param numericId This ID is intended for systems (e.g. Yieldigo) that need numeric IDs.
   * @param name family name
   * @param tierId the id of tier related to this family
   * @param bindings the array of family bindings, each binding is related to a product
   */
  function Family(id, numericId, name, tierId) {
    var _this;

    var bindings = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : immutable_1.List();

    _classCallCheck(this, Family);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Family).call(this));
    _this.id = id;
    _this.numericId = numericId;
    _this.name = name;
    _this.tierId = tierId;
    _this.bindings = bindings;
    return _this;
  }
  /**
   * Converter from data-dictionary representation.
   */


  _createClass(Family, [{
    key: "removeBinding",

    /**
     * Removes given binding from family bindings and returns new instance of family.
     *
     * @param binding the binding to removal
     * @returns new instance of family without given binding
     */
    value: function removeBinding(binding) {
      if (typeof this.bindings !== 'object' || this.bindings.size === 0) {
        return this;
      }

      var index = this.bindings.findIndex(function (b) {
        return b.productId === binding.productId;
      });
      return index === -1 ? this : this.copy('bindings', this.bindings.remove(index));
    }
  }, {
    key: "getBindingForProductId",
    value: function getBindingForProductId(productId) {
      return utils_1.Utils.undefinedToNull(this.bindings.find(function (b) {
        return b.productId === productId;
      }));
    }
  }], [{
    key: "fromDataDict",
    value: function fromDataDict(mat) {
      return new Family(mat.id, mat.numericId, mat.name, mat.tierId, mat.bindings);
    }
  }]);

  return Family;
}(DomainObject_1.DomainObject);

exports.Family = Family;
/**
 * Minimal correct value of size charger.
 */

Family.SIZE_CHARGER_MIN = -100;
Family.SIZE_CHARGER_MAX = 10000000;
Family.SIZE_RATIO_MIN = 0.000001;
Family.SIZE_RATIO_MAX = 10000000; // tslint:disable-next-line:member-ordering

Family.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Family.name);
  return {
    id: builder.str('id'),
    numericId: builder.num('numericId'),
    name: builder.str('name'),
    tierId: builder.str('tierId'),
    bindings: builder.listOf(builder.data('bindings', {
      productId: builder.str('productId'),
      sizeCharger: builder.bigNum('sizeCharger', new BigNumberRangeValidator_1.BigNumberRangeValidator(Family.SIZE_CHARGER_MIN, Family.SIZE_CHARGER_MAX)),
      sizeRatio: builder.bigNum('sizeRatio', new BigNumberRangeValidator_1.BigNumberRangeValidator(Family.SIZE_RATIO_MIN, Family.SIZE_RATIO_MAX))
    }))
  };
}();